import React from 'react'

const getPoweredByImage = site =>
  require(`../../../common_assets/images/powered-by-${site}.embedded.svg`)

export const PoweredBy = props => (
  <div className="powered-by-container">
    <span className="powered-by-text">{props.text} </span>
    <img className="powered-by-logo" src={getPoweredByImage(props.site)} />
  </div>
)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/logo/poweredBy.view.js